import { createSelector } from 'reselect';
import { getConnector } from '../services/PatientFacingClient';

export const messageIdSelector = (state, props) => props.messageId || props.id;
export const messageSelector = createSelector(
  getConnector,
  messageIdSelector,
  (connector, id) => connector.client.messages.getById(id),
);

export const messagesIdsSelector = state => Object.keys(state.messages);
export const messagesSelector = createSelector(
  getConnector,
  messagesIdsSelector,
  (connector, ids) => ids.map(id => connector.client.messages.getById(id)).sort((a, b) => a.sortNumber - b.sortNumber),
);
